// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './vuex/store'
import router from './router/index.js'
import VueResource from 'vue-resource'
import Vuetify from 'vuetify'
import vueSignature from 'vue-signature'
import Vuelidate from 'vuelidate'
import vl from 'vue-virtual-list'
import UUID from 'vue-uuid'
import snackbar from './components/Snackbar'
import customDialog from './components/Custom_Dialog'

require("vuetify/dist/vuetify.css")
require("./css/main.css")
require("./scss/main.scss")

Vue.use(customDialog)
Vue.use(snackbar)
Vue.use(UUID)
Vue.use(vl)
Vue.use(Vuelidate)
Vue.use(vueSignature)
Vue.config.productionTip = false
Vue.use(VueResource)
    Vue.use(Vuetify, {
        theme: {
            primary: "#79CE86",
            secondary: "#b0bec5",
            accent: "#8c9eff",
            error: "#b71c1c"
        }
    })

new Vue({
    store,
    router,
    template: `
        <div>
        <v-app>
        <router-view></router-view>
        <snackbar></snackbar>
        </v-app>
        </div>
    `,
    components: {
        snackbar: snackbar
    },
    data(){
        return{
            snackbarType: "",
            location: navigator.geolocation,
            watchedPos: {}
        }
    },
    methods: {
        getLocation() {
            console.log("getLocation in main");
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showPosition);
                this.$store.state.deviceLocation.lastSet = Date.now();
            } else {
                window.alert("Geolocation is not supported by this browser.");
            }
        },
        showPosition(position) {
            this.$store.state.deviceLocation.position = position;
            this.$store.state.deviceLocation.lastSet = Date.now();
            this.$store.state.deviceLocation.hasBeenSet = true;
        },
        geoError(){
            window.alert("Device location could not be found.")
        }
    },
    computed: {

    },
    created: function(){
        this.$store.state.submittionPromise = Promise.resolve();

        this.$store.state.deviceLocation.hasBeenSet = false;

        this.watchedPos = this.location.watchPosition(this.showPosition, this.geoError, {enableHighAccuracy: false, timeout: Infinity, maximumAge: 300000 });

        window.addEventListener('focus', () => {
            if (navigator.onLine && this.$store.state.transactions.length > 0) {
                this.$store.commit('commitTransactions');
            }
        })

    }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js